module.exports = __webpack_public_path__ + "media/images/icons/twitter_share_yellow-6b7f573345b99238673d84e4ac158a00.svg";